/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_SubtitleInputs */

const en_landing_leadership_subtitle = /** @type {(inputs: Landing_Leadership_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Institutional experience behind the infrastructure.`)
};

/**
* | output |
* | --- |
* | "Institutional experience behind the infrastructure." |
*
* @param {Landing_Leadership_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_subtitle = /** @type {((inputs?: Landing_Leadership_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_subtitle(inputs)
});